import React from "react";

const SummaryConfigs = (props) => {
  const { payload, errors, summary, step, handleClick } = props;

  const {
    config_name,
    operation,
    receive_from,
    push_back_nodes,
    router_configuration,
    segments = [],
    unique_identifier_type,
    filters = [],
  } = summary;

  const handleSubmit = (values) => {
    // addHL7Config(values);
    handleClick("submit");
  };

  const nodesWithNodeProperty = push_back_nodes.filter((node) => node.node);

  return (
    <div className="hl7-modal-inputs p-3">
      <div>
        <div className="mb-2 fs-5 fw-bold carpl_color">Summary:</div>
        <div className="mb-2">
          <strong className="label-fields-beige">Config Name:</strong>{" "}
          {config_name}
        </div>
        <div className="mb-2">
          <strong className="label-fields-beige">Source:</strong> {receive_from}
        </div>
        <div className="mb-2">
          <strong className="label-fields-beige">Operation:</strong> {operation}
        </div>
        <div className="mb-2">
          <strong className="label-fields-beige">Router Configuration:</strong>{" "}
          {router_configuration}
        </div>
        <div className="mb-2">
          <strong className="label-fields-beige">
            Unique Identifier Type:
          </strong>{" "}
          {unique_identifier_type}
        </div>
        <div className="mb-2">
          <strong className="label-fields-beige">Segments:</strong>
          {segments.length > 0 ? (
            <ul className="mt-1 mb-0">
              {segments.map((segment, index) => (
                <li key={index}>
                  <strong>Type:</strong> {segment.segment_name},{" "}
                  <strong>Code:</strong> {segment.field_number}
                </li>
              ))}
            </ul>
          ) : (
            <span>None</span>
          )}
        </div>
        <div className="mb-2">
          <strong className="label-fields-beige">Filters: </strong>
          {filters.length > 0 ? (
            <ul className="mt-1 mb-0">
              {filters.map((filter, index) => (
                <li key={index}>
                  <strong>Tag ID:</strong> {filter.tag_id},{" "}
                  <strong>Values:</strong> {filter.value.join(", ")}
                </li>
              ))}
            </ul>
          ) : (
            <span>None</span>
          )}
        </div>
        {nodesWithNodeProperty.length > 0 && (
          <div>
            <strong className="label-fields-beige">Push Back Nodes:</strong>
            <ul className="mt-1 mb-0">
              {nodesWithNodeProperty.map((node, index) => (
                <li key={index}>
                  <strong>Operation:</strong> {node.operation_name},{" "}
                  <strong>Node:</strong> {node.node}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div className="d-flex justify-content-center">
        {step !== 0 && (
          <div className="">
            <button
              className="btn-class mt-3 "
              type="submit"
              name="btn-click"
              style={{ marginLeft: "1rem", marginRight: "1rem" }}
              onClick={() => handleClick("prev")}
            >
              PREV
            </button>
          </div>
        )}
        <div
          className="btn-class  text-center "
          onClick={() => handleSubmit(payload)}
        >
          SUBMIT
        </div>
      </div>
    </div>
  );
};

export default SummaryConfigs;
